import Cookies from 'js-cookie';
import { apiAction, logEntry } from '../utils/index';

import {
  SIGNALTRANSLATION_EQUATION_ERROR,
  GET_ALL_SIGNALTRANSLATION_EQUATION_DETAILS,
  SIGNALTRANSLATION_EQUATION_IS_LOADING,
  SET_SIGNALTRANSLATION_EQUATION_CURRENT_PAGE,
  SET_SIGNALTRANSLATION_EQUATION_PAGE_FILTER,
  SET_SIGNALTRANSLATION_EQUATION,
  SET_SIGNALTRANSLATION_EQUATION_CHANGE,
  SET_SIGNALTRANSLATION_EQUATION_CLEANUP,
  UPDATE_SIGNALTRANSLATION_EQUATION_SAVE_STATUS,
  SET_SIGNALTRANSLATION_EQUATION_CONSTANT_CHANGE,
  SET_SIGNALTRANSLATION_EQUATION_CONSTANT_LIST_CHANGE,
  SHOW_SIGNALTRANSLATION_EQUATION_CONSTANT_ADD_EDIT_SCREEN
} from '../constants/index';

import { SIGNALTRANSLATION_EQUATION_MANAGEMENT, CREATE_SIGNALTRANSLATION_EQUATION, UPDATE_SIGNALTRANSLATION_EQUATION } from '../constants/logs';

const envName = process.env.REACT_APP_ENV_NAME_SHORT;

export const setSignalTranslationEquationErrorThunk = err => dispatch => {
  let messageCode = err && err.response && err.response.data && err.response.data.errorMessage;
  messageCode = messageCode && messageCode.replace('[400]=>', '');
  dispatch(setSignalTranslationEquationError(messageCode, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setSignalTranslationEquationError(messageCode, false));
  }, 2500);
};

export const setSignalTranslationEquationCustomErrorThunk = (messageCode, status) => dispatch => {
  dispatch(setSignalTranslationEquationError(messageCode, true));
  setTimeout(() => {
    dispatch(setSignalTranslationEquationError('', false));
  }, 5000);
};

export const setSignalTranslationEquationError = (messageCode, status) => {
  return {
    type: SIGNALTRANSLATION_EQUATION_ERROR,
    payload: {
      data: {
        isOpSuccessful: false,
        showBanner: status,
        isLoading: false,
        displayMessageCode: messageCode || ''
      }
    }
  };
};

export const setLoadingStatus = isLoading => ({
  type: SIGNALTRANSLATION_EQUATION_IS_LOADING,
  payload: { isLoading: isLoading }
});

export const getSignalTranslationEquationThunk = (filterObj, widgetCode, moodelCategoryId) => dispatch => {
  dispatch(getSignalTranslationEquation(filterObj, widgetCode, moodelCategoryId));
};

export const getSignalTranslationEquation = (filterObj, widgetCode, moodelCategoryId) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/signalTranslationequations`,
    data: {
      Offset: filterObj.offset,
      Limit: filterObj.limit,
      Filter: filterObj.filter,
      ModelCategoryId: moodelCategoryId || undefined
    },
    method: 'GET',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setAllSignalTranslationEquationListThunk(retData),
    onFailure: err => setSignalTranslationEquationErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setAllSignalTranslationEquationListThunk = retData => dispatch => {
  let messageCode = retData && retData.message;
  let signalTranslationEquation = (retData && retData.signalTranslationEquation) || [];
  dispatch(setAllSignalTranslationEquationList(messageCode, signalTranslationEquation));
};

export const setAllSignalTranslationEquationList = (messageCode, signalTranslationEquation) => ({
  type: GET_ALL_SIGNALTRANSLATION_EQUATION_DETAILS,
  payload: {
    data: {
      SignalTranslationEquationList: signalTranslationEquation,
      isLoading: false,
      displayMessageCode: messageCode,
      showBanner: false,
      isOpSuccessful: false
    }
  }
});

export const setCurrentPage = currentPage => ({
  type: SET_SIGNALTRANSLATION_EQUATION_CURRENT_PAGE,
  payload: { currentPage }
});

export const setPageFilter = filter => ({
  type: SET_SIGNALTRANSLATION_EQUATION_PAGE_FILTER,
  payload: { filter }
});

export const describeSignalTranslationEquationThunk = (SignalTranslationEquationId, widgetCode, modelCategoryId) => dispatch => {
  dispatch(describeSignalTranslationEquation(SignalTranslationEquationId, widgetCode, modelCategoryId));
};

export const describeSignalTranslationEquation = (SignalTranslationEquationId, widgetCode, modelCategoryId) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/signalTranslationequations`,
    data: {
      SignalTranslationEquationId: SignalTranslationEquationId || undefined,
      ModelCategoryId: modelCategoryId || undefined
    },
    method: 'GET',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setSignalTranslationEquationThunk(retData),
    onFailure: err => setSignalTranslationEquationErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setSignalTranslationEquationThunk = ({ retData }) => dispatch => {
  let data = (retData.signalTranslationEquation && retData.signalTranslationEquation[0]) || null;
  let describeSignalTranslation = {};
  if (data) {
    describeSignalTranslation = {
      SignalTranslationEquationId: data.SignalTranslationEquationId,
      Name: data.Name,
      Description: data.Description,
      Formula: data.Formula,
      GuidIdentifier: data.GuidIdentifier,
      IsActive: data.IsActive,
      EquationConstants: {
        EquationConstantList: data.SignalTranslationConstants,
        SelectedEquationConstant: {
          SignalTranslationEquationConstantId: 0,
          SignalTranslationEquationId: 0,
          Name: '',
          Description: '',
          GuidIdentifier: '',
          isChanged: 0,
          IsActive: true,
          OrderNumber: 0
        },
        showAddEditScreen: false
      }
    };
  }

  dispatch(setSignalTranslationEquation(describeSignalTranslation));
};

export const setSignalTranslationEquation = data => ({
  type: SET_SIGNALTRANSLATION_EQUATION,
  payload: data
});

export const saveSignalTranslationEquationThunk = (SignalTranslationEquation, widgetCode) => dispatch => {
  let url = '/management/signalTranslationequations/save';
  let actionName = SignalTranslationEquation.SignalTranslationEquationId === 0 ? CREATE_SIGNALTRANSLATION_EQUATION : UPDATE_SIGNALTRANSLATION_EQUATION;
  let log = logEntry(SIGNALTRANSLATION_EQUATION_MANAGEMENT, actionName, SignalTranslationEquation);
  dispatch(saveSignalTranslationEquation(SignalTranslationEquation, url, log, widgetCode));
};

export const saveSignalTranslationEquation = (SignalTranslationEquation, url, log, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}${url}`,
    method: 'POST',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setSignalTranslationEquationStatusThunk(retData),
    onFailure: err => setSignalTranslationEquationErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {
      SignalTranslationEquation: SignalTranslationEquation,
      log: log
    },
    widgetcode: widgetCode
  });

export const setSignalTranslationEquationStatusThunk = retData => dispatch => {
  let messageCode = retData;
  dispatch(setSignalTranslationEquationStatus(messageCode, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setSignalTranslationEquationStatus('', false));
  }, 2500);
};

export const setSignalTranslationEquationStatus = (messageCode, status) => ({
  type: UPDATE_SIGNALTRANSLATION_EQUATION_SAVE_STATUS,
  payload: {
    data: {
      isOpSuccessful: true,
      showBanner: status,
      isLoading: false,
      displayMessageCode: messageCode || ''
    }
  }
});

export const setSignalTranslationEquationChangeThunk = retData => dispatch => {
  dispatch(setSignalTranslationEquationChange(retData));
};

export const setSignalTranslationEquationChange = retData => ({
  type: SET_SIGNALTRANSLATION_EQUATION_CHANGE,
  payload: retData
});

export const setSignalTranslationEquationCleanUpThunk = () => dispatch => {
  dispatch(setSignalTranslationEquationCleanUp());
};

export const setSignalTranslationEquationCleanUp = () => ({
  type: SET_SIGNALTRANSLATION_EQUATION_CLEANUP,
  payload: {}
});

export const setSignalTranslationEquationConstantThunk = retData => dispatch => {
  dispatch(setSignalTranslationEquationConstantChange(retData));
};

export const setSignalTranslationEquationConstantChange = retData => ({
  type: SET_SIGNALTRANSLATION_EQUATION_CONSTANT_CHANGE,
  payload: retData
});

export const showAddEditSreenThunk = status => dispatch => {
  dispatch(showAddEditSreen(status));
};

export const showAddEditSreen = status => ({
  type: SHOW_SIGNALTRANSLATION_EQUATION_CONSTANT_ADD_EDIT_SCREEN,
  payload: { showAddEditScreen: status }
});

export const setSignalTranslationEquationConstantListThunk = retData => dispatch => {
  dispatch(setSignalTranslationEquationConstantList(retData));
};

export const setSignalTranslationEquationConstantList = retData => ({
  type: SET_SIGNALTRANSLATION_EQUATION_CONSTANT_LIST_CHANGE,
  payload: retData
});
